import React from 'react'
import TermsOfService from '../components/TermsOfService'

export default function TermsOfServicePage() {
  return (
    <div className="legal-page">
      <TermsOfService isModal={false} />
    </div>
  )
}